import React, { useEffect, useState, useCallback } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useDropzone } from 'react-dropzone';
import Modal from 'react-bootstrap/Modal';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { BASE_URL } from '../../Utils/base_url';
import { AjoutePresentation, AffichePresentation, AfficheData } from '../../Api/RestaurantApi/PresentationApi';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import { PhotoProvider, PhotoView } from 'react-photo-view';

// Visualiser
import Slider from "react-slick";
import Chef from "../../Image/chef.png";
import EntrerIcon from "../../Image/entrer.png";
import PlatIcon from "../../Image/plats.png";
import DessertIcon from "../../Image/desserts.png";
import BoissonIcon from "../../Image/boisson.png";
import Money from "../../Image/money.png";
import Plus from "../../Image/plus.png";
import Menus from "../../Image/menus.png";
import Avatar1 from "../../Image/avatar1.png";
import Avatar2 from "../../Image/Avatar2.png";



import './css/profileResto.css';

const ProfileResto = () => {
    const [selectImage, setSelectImage] = useState([]);
    const [description, setDescription] = useState('');
    const [precision, setPrecision] = useState('');
    const [plan, setPlan] = useState();
    const [planUrl, setPlanUrl] = useState('');
    const [icon, setIcon] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [fullscreen, setFullscreen] = useState(true);
    const [errorImage, setErrorImage] = useState('');
    const [errorMap, setErrorMap] = useState('');
    const [loading, setLoading] = useState(false);
    const [loadData, setLoadData] = useState(false);

    // Visualiser

    const [show, setShow] = useState(false);
    const [showSpecial, setShowSpecial] = useState(false);

    const [prixMoyen, setPrixMoyenne] = useState([]);
    const [promotion, setPromotion] = useState([]);
    const [entrer, setEntrer] = useState([]);
    const [plat, setPlat] = useState([]);
    const [dessert, setDessert] = useState([]);
    const [menu, setMenu] = useState([]);
    const [elementMenu, setElementMenu] = useState([]);
    const [promoSpecial, setPromoSpecial] = useState([]);
    const [boisson, setBoisson] = useState([]);

    console.log("description=>", description);

    // useEffect(() => {
    //     const idResto = JSON.parse(localStorage.getItem('idResto'));
    //     if (idResto) {
    //       AfficheRestaurant(idResto)
    //       .then(function (response) {
    //         console.log("donner resto",response.data.donner);
    //         dispatch(AjouteRestaurant(response.data.donner));
    //       })
    //       .catch(function (error) {
    //         console.log(error);
    //       });
    //     }
    //   }, []);


    var settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        pauseOnHover: true,
        speed: 2000,
        autoplaySpeed: 8000,
        swipeToSlide: true,
        slidesToShow: selectImage.length < 4 ? selectImage.length : 4,
        slidesToScroll: selectImage.length < 4 ? selectImage.length : 4,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: selectImage.length < 3 ? selectImage.length : 3,
                    slidesToScroll: selectImage.length < 3 ? selectImage.length : 3,
                    initialSlide: selectImage.length < 3 ? selectImage.length : 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: selectImage.length < 2 ? selectImage.length : 2,
                    slidesToScroll: selectImage.length < 2 ? selectImage.length : 2,
                    initialSlide: selectImage.length < 2 ? selectImage.length : 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: selectImage.length < 1 ? selectImage.length : 1,
                    slidesToScroll: selectImage.length < 1 ? selectImage.length : 1
                }
            },
            {
                breakpoint: 320,
                settings: {
                    slidesToShow: selectImage.length < 1 ? selectImage.length : 1,
                    slidesToScroll: selectImage.length < 1 ? selectImage.length : 1
                }
            }
        ]
    };



    const handleCloseDetailMenu = () => setShow(false);
    const handleShowDetailMenu = (el) => {
        setElementMenu(el);
        setShow(true);

    };

    const handleCloseDetailSpecial = () => setShowSpecial(false);
    const handleShowDetailSPecial = () => {
        setShowSpecial(true);

    };






    const viewPromotion = () => {
        const existePromo50 = promotion.find((el) => el.libelle === "Promotion de -50%");
        const existePromo40 = promotion.find((el) => el.libelle === "Promotion de -40%");
        const existePromo30 = promotion.find((el) => el.libelle === "Promotion de -30%");
        const existePromo20 = promotion.find((el) => el.libelle === "Promotion de -20%");
        const existePromo10 = promotion.find((el) => el.libelle === "Promotion de -10%");
        const existePromoSpecial = promotion.find((el) => el.libelle === "Promotion : Menu spécial");

        if (existePromo50) {
            return (<span><i className='fa fa-bullhorn'></i>Promotion -50%</span>);
        } else if (existePromo40) {
            return (<span><i className='fa fa-bullhorn'></i>Promotion -40%</span>);
        } else if (existePromo30) {
            return (<span><i className='fa fa-bullhorn'></i>Promotion -30%</span>);
        } else if (existePromo20) {
            return (<span><i className='fa fa-bullhorn'></i>Promotion -20%</span>);
        } else if (existePromo10) {
            return (<span><i className='fa fa-bullhorn'></i>Promotion -10%</span>);
        } else if (existePromoSpecial) {
            return (<span><i className='fa fa-bullhorn'></i>Menu spécial</span>);

        } else {
            return (<span><i className='fa fa-bullhorn'></i>Pas de promotion ...</span>);
        }


    }



    const viewCreneau = (creneau) => {
        var opt_month = { month: 'long' };
        function toTitleCase(str) {
            return str.replace(
                /\w\S*/g,
                function (txt) {
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                }
            );
        }
        var MonthDu = toTitleCase(new Date(creneau?.du).toLocaleDateString("fr-FR", opt_month));
        var MonthAu = toTitleCase(new Date(creneau?.au).toLocaleDateString("fr-FR", opt_month));
        const du = new Date(creneau?.du);
        const au = new Date(creneau?.au);
        const fin = new Date(creneau?.au).getTime();
        const date = new Date();
        if (fin >= date.getTime()) {
            return (<p>{du.getDate() + " " + MonthDu + " " + du.getFullYear()} au {au.getDate() + " " + MonthAu + " " + au.getFullYear()}</p>);
        } else {
            return (<p>Promotion Expirée !</p>)
        }
    }


    // Fin Visualiser




    const [cuisine, setCuisine] = useState([]);

    const [quartier, setQuartier] = useState([]);

    const [cadre, setCadre] = useState([]);

    const [service, setService] = useState([]);



    const [regime, setRegime] = useState([]);


    const [payement, setPayement] = useState([]);




    // VISUALISER

    const existeService = service.filter((el) => el.check === true);
    const existeRegime = regime.filter((el) => el.check === true);
    const existePayement = payement.filter((el) => el.check === true);

    //FIN 



    let location = useLocation();

    const restaurant = useSelector((state) => state.restaurant);




    useEffect(() => {
        data();
        presentation();
    }, []);

    const data = () => {
        AfficheData().then(function (response) {
            console.log('Data resto=>', response.data.donner);
            response.data.donner.typeCuisine.map((el, i) => {
                return setCuisine((prev) => [...prev, { id: i + 1, name: el.libelle, check: false }]);
            });
            response.data.donner.quartier.map((el, i) => {
                return setQuartier((prev) => [...prev, { id: i + 1, name: el.libelle, check: false }]);
            });
            response.data.donner.cadre.map((el, i) => {
                return setCadre((prev) => [...prev, { id: i + 1, name: el.libelle, check: false }]);
            });
            response.data.donner.service.map((el, i) => {
                return setService((prev) => [...prev, { id: i + 1, name: el.libelle, check: false }]);
            });
            response.data.donner.regime.map((el, i) => {
                return setRegime((prev) => [...prev, { id: i + 1, name: el.libelle, check: false }]);
            });
            response.data.donner.payement.map((el, i) => {
                return setPayement((prev) => [...prev, { id: i + 1, name: el.libelle, check: false }]);
            })
        }).catch(function (error) {
            console.log(error);
        });
    }

    const presentation = () => {
        setLoadData(true);
        AffichePresentation(restaurant.id).then(function (response) {
            console.log(response.data.donner);
            setDescription(response.data.donner.description);
            setPlanUrl(response.data.donner.urlPlan);
            setPrecision(response.data.donner.precision);
            setPrixMoyenne(response.data.donner.prixMoyenne);
            setPromotion(response.data.donner.promotions);
            setEntrer(response.data.donner.entrers);
            setPlat(response.data.donner.plats);
            setDessert(response.data.donner.desserts);
            setMenu(response.data.donner.menus);
            setPromoSpecial(response.data.donner.promoSpecial);
            console.log(response.data.donner.promoSpecial);
            setBoisson(response.data.donner.boissons);
            response.data.donner.typeCuisines.map((el) =>
                setCuisine((prev) => {
                    return prev.map((item) => {
                        if (item.name === el.libelle) {
                            return { ...item, check: true };
                        } else {
                            return { ...item };
                        }
                    });
                }));
            response.data.donner.quartiers.map((el) =>
                setQuartier((prev) => {
                    return prev.map((item) => {
                        if (item.name === el.libelle) {
                            return { ...item, check: true };
                        } else {
                            return { ...item };
                        }
                    });
                }));
            response.data.donner.cadreAmbiances.map((el) =>
                setCadre((prev) => {
                    return prev.map((item) => {
                        if (item.name === el.libelle) {
                            return { ...item, check: true };
                        } else {
                            return { ...item };
                        }
                    });
                }));
            response.data.donner.cadreAmbiances.map((el) =>
                setCadre((prev) => {
                    return prev.map((item) => {
                        if (item.name === el.libelle) {
                            return { ...item, check: true };
                        } else {
                            return { ...item };
                        }
                    });
                }));
            response.data.donner.serviceRestaurant.map((el) =>
                setService((prev) => {
                    return prev.map((item) => {
                        if (item.name === el.libelle) {
                            return { ...item, check: true };
                        } else {
                            return { ...item };
                        }
                    });
                }));
            response.data.donner.regimeAlimentaires.map((el) =>
                setRegime((prev) => {
                    return prev.map((item) => {
                        if (item.name === el.libelle) {
                            return { ...item, check: true };
                        } else {
                            return { ...item };
                        }
                    });
                }));
            response.data.donner.payements.map((el) =>
                setPayement((prev) => {
                    return prev.map((item) => {
                        if (item.name === el.libelle) {
                            return { ...item, check: true };
                        } else {
                            return { ...item };
                        }
                    });
                }));

            response.data.donner.photos.map((el, index) => setSelectImage((prev) => [...prev, { id: index + 1, type: 'base', photo: el.photo, base: el.basePhoto, file: el.urlPhoto }]));


        }).catch(function (error) {
            console.log(error);
        }).finally(function () {
            setLoadData(false);
        });
    }









    // Dropzone
    const onDrop = useCallback((acceptedFiles, rejectFiles) => {
        acceptedFiles.forEach((file, index) => {
            const isValidType =
                file.type === "image/jpeg" ||
                file.type === "image/jpg" ||
                file.type === "image/png";

            const isValidSize = file.size <= 1 * 1024 * 1024; // 1 Mo

            if (!isValidType) {
                setErrorImage('❌ Format accepté : PNG, JPEG, JPG');
                const timer = setTimeout(() => setErrorImage(''), 4000);
                return () => clearTimeout(timer);
            }

            if (!isValidSize) {
                setErrorImage(`❌ L'image "${file.name}" dépasse 1 Mo et n'a pas été ajoutée.`);
                const timer = setTimeout(() => setErrorImage(''), 4000);
                return () => clearTimeout(timer);
            }

            const reader = new FileReader();
            reader.onload = () => {
                setSelectImage(prevState => [
                    ...prevState,
                    {
                        id: index + 1,
                        type: 'local',
                        photo: "nouveau",
                        base: "nouveau",
                        file: reader.result
                    }
                ]);
            };
            reader.readAsDataURL(file);
        });


    }, []);

    useEffect(() => {
    }, [selectImage])

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: 'image/*',
    });

    console.log(getRootProps(), getInputProps());

    // Fin Dropzone



    // Drag and Drop
    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    }

    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
        const reorderedItems = reorder(selectImage, result.source.index, result.destination.index);

        console.log(reorder);

        setSelectImage(reorderedItems);

    }

    const grid = 8;
    const getListStyle = (isDraggingOver) => ({
        background: isDraggingOver ? 'lightblue' : 'white',
        display: 'flex',
        padding: grid,
        overflow: 'auto',
        marginTop: '10px'
    });

    const getItemStyle = (isDragging, draggableStyle) => ({
        userSelect: 'none',
        padding: grid * 2,
        margin: `0 ${grid}px 0 0`,
        background: isDragging ? 'white' : 'white',
        ...draggableStyle
    });

    // FIN Drag and Drop



    const handleCheckCuisine = id => {
        setCuisine((prev) => {
            return prev.map((item) => {
                if (item.id === id) {
                    return { ...item, check: !item.check };
                } else {
                    return { ...item };
                }
            });
        });
    }

    const handleCheckQuartier = id => {
        setQuartier((prev) => {
            return prev.map((item) => {
                if (item.id === id) {
                    return { ...item, check: !item.check };
                } else {
                    return { ...item };
                }
            });
        });
    }



    const handleCheckCadre = id => {
        setCadre((prev) => {
            return prev.map((item) => {
                if (item.id === id) {
                    return { ...item, check: !item.check };
                } else {
                    return { ...item };
                }
            });
        });
    }


    const handleCheckService = id => {
        setService((prev) => {
            return prev.map((item) => {
                if (item.id === id) {
                    return { ...item, check: !item.check };
                } else {
                    return { ...item };
                }
            });
        });
    }

    const handleCheckRegime = id => {
        setRegime((prev) => {
            return prev.map((item) => {
                if (item.id === id) {
                    return { ...item, check: !item.check };
                } else {
                    return { ...item };
                }
            });
        });
    }



    const handleCheckPayement = id => {
        setPayement((prev) => {
            return prev.map((item) => {
                if (item.id === id) {
                    return { ...item, check: !item.check };
                } else {
                    return { ...item };
                }
            });
        });
    }



    const handleClose = () => setShowModal(false);
    const handleShow = (breakpoint) => {
        setFullscreen(breakpoint);
        setShowModal(true);
    };


    let dataCuisine = cuisine.filter((el) => el.check === true);
    let dataQuartier = quartier.filter((el) => el.check === true);
    let dataCadre = cadre.filter((el) => el.check === true);
    let dataService = service.filter((el) => el.check === true);
    let dataRegime = regime.filter((el) => el.check === true);
    let dataPayement = payement.filter((el) => el.check === true);





    const handleMap = (e) => {
        const file = e.target.files[0];
        const maxSize = 1 * 1024 * 1024; // 1 Mo

        if (!file) return;

        const isValidType =
            file.type === "image/jpeg" ||
            file.type === "image/jpg" ||
            file.type === "image/png";

        const isValidSize = file.size <= maxSize;

        if (!isValidType) {
            setErrorMap('❌ Format accepté : PNG, JPEG, JPG');
            const timer = setTimeout(() => setErrorMap(''), 4000);
            return () => clearTimeout(timer);
        }

        if (!isValidSize) {
            setErrorMap(`❌ L'image "${file.name}" dépasse 1 Mo et n'a pas été ajoutée.`);
            const timer = setTimeout(() => setErrorMap(''), 4000);
            return () => clearTimeout(timer);
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
            const base64 = reader.result;
            setPlan(base64);
            setIcon(false);
        };

        reader.onerror = (error) => {
            console.error('Erreur lors du chargement de l\'image :', error);
        };
    };



    const handleAddPresentation = () => {
        console.log(selectImage);
        if (!localStorage.getItem('tokenSociete')) {
            setLoading(true);
            const data = { idRestaurant: restaurant.id, description: description, precision: precision, plan: plan, photos: selectImage, typeCuisine: dataCuisine, payement: dataPayement, quartier: dataQuartier, cadreAmbiance: dataCadre, regimeAlimentaireSpecifique: dataRegime, service: dataService };
            AjoutePresentation(data).then(function (response) {
                if (response.data.title === "success") {
                    toast.success(response.data.message);
                    setSelectImage([]);
                    presentation();
                }
            }).catch(function (error) {
                console.log(error.response);
                toast.warning(error.response.data.message);
            }).finally(function () {
                setDescription('');
                setPrecision('');
                setPlan('');
                setIcon(true);
                setLoading(false);

            });
        } else {
            toast.warning("Vous n'êtes pas autorisé à modifier ces éléments");
        }

    }


    const handleCancel = () => {
        setSelectImage("");
        setDescription('');
        setPrecision('');
        setPlan('');
        setIcon(true);
        presentation();
    }
    console.log(planUrl);

    console.log(restaurant);


    const plural = (value) => {
        if (value < 10) {
            return "0" + value;
        } else {
            return value;
        }
    }

    const viewDate = (value) => {
        const date = new Date(value);
        return plural(date.getDate()) + "/" + plural(parseInt(date.getUTCMonth() + 1)) + "/" + date.getFullYear();
    }



    const viewAvisListe = (item, index) => {
        const nom = item.client.nom.charAt(0).toUpperCase();
        const prenom = item.client.prenom.charAt(0).toUpperCase();
        const clientAvis = restaurant.avis.filter((el) => el.client.id === item.client.id);
        return (
            <div className='resto_avis_liste' key={index}>
                <div className='row'>
                    <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
                        <div className='resto_avis_profile'>
                            <div className='resto_avatar_client'>
                                {
                                    item.client.sexe === "Homme" ? <img src={Avatar2} alt="avatar client" /> : <img src={Avatar1} alt="avatar client" />
                                }
                            </div>
                            {item.client.affichagePseudo === "1" ?
                                <div className='pseudoClient d-flex flex-column'>
                                    <span>{item.client.nom}</span>
                                    <span className='text-center'>{item.client.prenom}</span>
                                </div>
                                : item.client.affichagePseudo === "2" ?
                                    <span>{item.client.prenom} {nom}</span>
                                    : item.client.affichagePseudo === "3" ?
                                        <span>{prenom} {item.client.prenom}</span>
                                        : <span>{nom} {prenom}</span>}
                        </div>
                    </div>
                    <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
                        <div className='resto_note_avis'>
                            <div className='d-flex justify-content-center'>
                                <div className='note_avis_content'>
                                    <div>
                                        <div className='resto_note_value'>Note/<span>{item.notes[0]?.note}</span></div>
                                        <div className='resto_avis_value'>Avis/<span>{clientAvis.length}</span></div>
                                    </div>
                                </div>
                            </div>
                            <div className='resto_avis_date'>
                                <span>{viewDate(item.createdAt)}</span>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                        <div className='resto_content_avis'>
                            <p>{item.avis}</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div>
            <Helmet>
                <title>Présentation</title>
                <meta name='description' content='Réprésentaion du restaurant.' />
                <link rel='canonical' href={location.pathname} />
            </Helmet>
            <div className='container'>
                <div className='presentation'>
                    <div className='row'>
                        <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                            <div className='a_propos'>
                                <div className='d-flex'>
                                    <i className='fa fa-home'></i> <h1>{restaurant.nomRestaurant}</h1>
                                </div>
                                <div className='d-flex mt-2'>
                                    <i className='fa fa-map-marker'></i> <h2>{restaurant.adresse}</h2>
                                </div>
                                <div className='d-flex mt-2'>
                                    <i className='fa fa-phone'></i>  <h2>{restaurant.telephone}</h2>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                            <div className='description'>
                                <div className='d-flex mt-2' >
                                    <i className='fa fa-newspaper-o'></i> <h2>Description :</h2>
                                </div>
                                <form>

                                    {loadData === true ? <div className="d-flex justify-content-center mt-4">
                                        <Spinner animation="border" className="load" variant="info" size="md" />
                                    </div> : <textarea className='form-control' maxLength={472} rows="6" value={description} onChange={(e) => setDescription(e.target.value)} placeholder='Description ...'></textarea>}
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className='choix'>
                        <div className='block_choix'>
                            <div className='d-flex mt-2'>
                                <i className='fa fa-cutlery'></i> <h3>Type de cuisine :</h3>
                            </div>
                            <div className='check'>
                                {cuisine.length === 0 ? <p>Pas disponible ...</p> : cuisine.map((cuisine, indexCuisine) => {
                                    return (
                                        <div className="form-check form-check-inline" key={indexCuisine}>
                                            <input className="form-check-input" type="checkbox" checked={cuisine.check} name="cuisine" id={cuisine.name} onChange={() => handleCheckCuisine(cuisine.id)} />
                                            <label className="form-check-label" htmlFor={cuisine.name}>{cuisine.name}</label>
                                        </div>
                                    )
                                })}

                            </div>

                        </div>
                        <div className='mt-4 block_choix'>

                            <div className='d-flex mt-2'>
                                <i className='fa fa-map'></i> <h3>Quartier :</h3>
                            </div>
                            <div className='check '>
                                {quartier.length === 0 ? <p>Pas disponible ...</p> : quartier.map((quartier, indexQuartier) => {
                                    return (
                                        <div className="form-check form-check-inline" key={indexQuartier}>
                                            <input className="form-check-input" type="checkbox" checked={quartier.check} onChange={() => handleCheckQuartier(quartier.id)} name="quartier" id={quartier.name} />
                                            <label className="form-check-label" htmlFor={quartier.name}>{quartier.name}</label>
                                        </div>
                                    );
                                })}
                            </div>

                        </div>
                        <div className='mt-4 block_choix'>

                            <div className='d-flex mt-2'>
                                <i className='fa fa-bullhorn'></i> <h3>Cadre et Ambiance  :</h3>
                            </div>
                            <div className='check'>
                                {cadre.length === 0 ? <p>Pas disponible ...</p> : cadre.map((cadre, indexCadre) => {
                                    return (
                                        <div className="form-check form-check-inline" key={indexCadre}>
                                            <input className="form-check-input" type="checkbox" checked={cadre.check} onChange={() => handleCheckCadre(cadre.id)} name="cadre" id={cadre.name} />
                                            <label className="form-check-label" htmlFor={cadre.name}>{cadre.name}</label>
                                        </div>
                                    );
                                })}
                            </div>

                        </div>
                        <div className='mt-4 block_choix'>

                            <div className='d-flex mt-2'>
                                <i className='fa fa-cogs'></i> <h3>Services  :</h3>
                            </div>
                            <div className='check'>
                                {service.length === 0 ? <p>Pas disponible ...</p> : service.map((service, indexService) => {
                                    return (
                                        <div className="form-check form-check-inline" key={indexService}>
                                            <input className="form-check-input" type="checkbox" checked={service.check} onChange={() => handleCheckService(service.id)} name="service" id={service.name} />
                                            <label className="form-check-label" htmlFor={service.name}>{service.name}</label>
                                        </div>
                                    );
                                })}
                            </div>

                        </div>
                        <div className='mt-4 block_choix'>

                            <div className='d-flex mt-2'>
                                <i className='fa fa-coffee'></i>   <h3>Régime alimentaire spécifique :</h3>
                            </div>
                            <div className='check'>
                                {regime.length === 0 ? <p>Pas disponible ...</p> : regime.map((regime, indexRegime) => {
                                    return (
                                        <div className="form-check form-check-inline" key={indexRegime}>
                                            <input className="form-check-input" type="checkbox" checked={regime.check} onChange={() => handleCheckRegime(regime.id)} name="regime" id={regime.name} />
                                            <label className="form-check-label" htmlFor={regime.name}>{regime.name}</label>
                                        </div>
                                    );
                                })}
                            </div>

                        </div>
                        <div className='mt-4 block_choix'>

                            <div className='d-flex mt-2'>
                                <i className='fa fa-money'></i>   <h3>Mode de payement :</h3>
                            </div>
                            <div className='check'>
                                {payement.length === 0 ? <p>Pas disponible ...</p> : payement.map((payement, indexPayement) => {
                                    return (
                                        <div className="form-check form-check-inline" key={indexPayement}>
                                            <input className="form-check-input" type="checkbox" checked={payement.check} onChange={() => handleCheckPayement(payement.id)} name="payement" id={payement.name} />
                                            <label className="form-check-label" htmlFor={payement.name}>{payement.name}</label>
                                        </div>
                                    );
                                })}
                            </div>

                        </div>
                    </div>
                    <div className='image'>
                        <div className='d-flex mt-2 titre'>
                            <i className='fa fa-camera'></i>   <h3>Photos :</h3>
                        </div>
                        <div className='upload_image'>
                            <div className='d-flex justify-content-center'>
                                <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4'>
                                    <div className='dropzone' {...getRootProps()}>
                                        <div className='image_appareil'>
                                            <input {...getInputProps()} />
                                            <label htmlFor="fileInput" className="d-flex justify-content-center" id="fileLabel">
                                                {isDragActive ? <div className='avatar d-flex justify-content-center align-items-center'>
                                                    <i className='fa fa-cloud-download'></i>
                                                </div> : <div className='avatar d-flex justify-content-center align-items-center'>
                                                    <i className='fa fa-picture-o'></i>
                                                </div>}
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-center">
                                        {errorImage !== "" ? <span className="errorValue">{errorImage}</span> : ''}
                                    </div>
                                </div>
                            </div>
                            <div className='row mt-2'>
                                <DragDropContext onDragEnd={onDragEnd}>
                                    <Droppable droppableId="droppable" direction="horizontal">
                                        {(provided, snapshot) => (
                                            <div className="droppable" {...provided.droppableProps} ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)}>
                                                {loadData === true ?
                                                    <div className="d-flex justify-content-center">
                                                        <Spinner animation="border" className="load" variant="info" size="md" />
                                                    </div> :
                                                    selectImage.map((file, index) => {
                                                        if (file.type === "local") {

                                                            return (
                                                                <Draggable className='col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3' Draggable key={file.file} draggableId={file.file} index={index}>
                                                                    {(provided, snapshot) => (
                                                                        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}
                                                                            style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}>
                                                                            <div className='liste_image'>
                                                                                <div className='image_item'>
                                                                                    <img src={file.file} alt="produit restaurant" title='produit restaurant' />
                                                                                </div>
                                                                                <div className='d-flex justify-content-end'>
                                                                                    <i className='fa fa-close' onClick={() => setSelectImage(selectImage.filter((el) => el.file !== file.file))}></i>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </Draggable>
                                                            );
                                                        } else {
                                                            return (
                                                                <Draggable className='col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3' Draggable key={file.file} draggableId={file.file} index={index}>
                                                                    {(provided, snapshot) => (
                                                                        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}
                                                                            style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}>
                                                                            <div className='liste_image'>
                                                                                <div className='image_item'>
                                                                                    <img src={BASE_URL + file.file} alt="produit restaurant" title='produit restaurant' />
                                                                                </div>
                                                                                <div className='d-flex justify-content-end'>
                                                                                    <i className='fa fa-close' onClick={() => setSelectImage(selectImage.filter((el) => el.file !== file.file))}></i>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </Draggable>
                                                            );
                                                        }

                                                    })}
                                            </div>
                                        )}

                                    </Droppable>
                                </DragDropContext>
                            </div>
                        </div>
                    </div>
                    <div className='plan'>
                        <div className='plan_bloc'>
                            <div className='row'>
                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                    <div className='d-flex titre'>
                                        <i className='fa fa-map'></i>   <h3>Plan/adresse :</h3>
                                    </div>

                                    <div className='ms-3 mt-2'>
                                        <h4>Adresse : {restaurant.adresse}</h4>
                                        <div className='precision'>
                                            <h4>Précision :</h4>
                                            <form>
                                                <textarea className='form-control' value={precision} onChange={(e) => setPrecision(e.target.value)} placeholder='Precision ...'></textarea>
                                            </form>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                    <div className='image_plan'>
                                        <div className='image_appareil'>
                                            <input type="file" className="form-control" id="fileMap" onChange={(e) => handleMap(e)} required />
                                            <label htmlFor="fileMap" className="d-flex justify-content-center" id="fileLabel">
                                                {icon === true ?
                                                    <div className='avatarMap d-flex justify-content-center align-items-center'>
                                                        <i className='fa fa-map'></i>
                                                    </div>

                                                    : <img src={plan} alt="plan restaurant" className='plan_restaurant' />

                                                }
                                            </label>
                                        </div>
                                        <div className="d-flex justify-content-center">
                                            {errorMap !== "" ? <span className="errorValue">{errorMap}</span> : ''}
                                        </div>
                                    </div>
                                    {loadData === true ? <div className="d-flex justify-content-center mt-2">
                                        <Spinner animation="border" className="ms-5 load" variant="info" size="md" />
                                    </div> : planUrl === "" || planUrl === null ? ''
                                        : <div className='image_plan'>
                                            <div className='image_appareil'>
                                                <img src={BASE_URL + planUrl} alt="plan restaurant" className='plan_restaurant' />
                                            </div>
                                        </div>}
                                    <div className="d-flex justify-content-center">
                                        <h4 className='titre_plan'>Image plan ou géolocalisation</h4>
                                    </div>
                                </div>
                            </div>



                        </div>

                        <div className='bloc_action'>
                            <div className='d-flex justify-content-center'>
                                <button className='btn' onClick={() => handleShow(true)}>Visualiser</button>
                                <button className='btn' onClick={handleCancel}>Annuler</button>

                                {loading ? <Button className='btn btn_ajoutePresentation' disabled>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        variant="info"
                                        className="spiner"
                                    />
                                    Loading...
                                </Button> : <button className='btn' onClick={handleAddPresentation}>Publier</button>}

                            </div>
                        </div>
                        <p className='version'>Version 1</p>
                    </div>

                    {/* ==================================== MODAL COMPONENT  ============================== */}



                    <Modal show={showModal} fullscreen={fullscreen} onHide={handleClose}>
                        <Modal.Body>
                            <div className='modal_visualiser'>
                                <div className='modal_visualiser_header'>
                                    <h5>L'aperçue de votre donner dans la page restaurants</h5>
                                    <span className='close' onClick={handleClose}><i className='fa fa-close'></i></span>
                                </div>

                                <div className='restoPageProfile'>
                                    <div className='restoPage_content'>
                                        <div className='resto_option'>
                                            <div className='row'>
                                                <div className='col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8'>
                                                    <div className='resto_apropos'>
                                                        <div className='resto_apropos_content'>
                                                            <h1 className='text-center'>{restaurant.nomRestaurant}</h1>
                                                            <div className='cuisine_prix'>
                                                                <div className='row'>



                                                                    {cuisine.length !== 0 ?
                                                                        cuisine.map((el, i) => {
                                                                            if (el.check === true) {
                                                                                return (
                                                                                    <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 mt-3' key={i}>
                                                                                        <span ><i className='fa fa-cutlery'></i>{el.name}</span>
                                                                                    </div>
                                                                                );
                                                                            } else {
                                                                                return (
                                                                                    ''
                                                                                );
                                                                            }
                                                                        })
                                                                        : ''}
                                                                </div>
                                                                <div className='row'>
                                                                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
                                                                        <span><i className='fa fa-map-marker'></i>Adresse à {restaurant.adresse}</span>
                                                                    </div>
                                                                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
                                                                        <span><i className='fa fa-bookmark'></i>Prix Moyenne de {prixMoyen.length !== 0 ? prixMoyen[0]?.prix : "000"} Ar</span>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div className='favoris_gif'>
                                                                <i className='fa fa-heart'></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4'>
                                                    <div className='resto_favoris'>
                                                        <div className='resto_favoris_content'>
                                                            <div className="d-flex justify-content-center">
                                                                <div className='resto_note_avis'>
                                                                    <div>
                                                                        <div className='resto_note'>Note/<span>{restaurant && restaurant.notes && restaurant.notes.length > 0 ? restaurant.notes[0].note : 0}</span></div>
                                                                        <div className='resto_avis'>Avis/<span>{restaurant && restaurant.avis ? restaurant.avis.length : 0}</span></div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="d-flex justify-content-center">
                                                                {promotion.length === 0 ? <div className='resto_promotion mb-4'>
                                                                    {viewPromotion()}
                                                                </div> :
                                                                    <div className='resto_promotion'>
                                                                        {viewPromotion()}
                                                                        {restaurant.creneauPromos.lenght !== 0 ?
                                                                            viewCreneau(restaurant.creneauPromos[0])
                                                                            : ''}


                                                                    </div>}
                                                            </div>
                                                        </div>
                                                        <div className='resto_footer_reserver'>
                                                            <div className='d-flex justify-content-center'>
                                                                <button className="btn">Réserver</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>



                                        <PhotoProvider>
                                            <div className='resto_photos'>
                                                {selectImage.length !== 0 ?
                                                    <Slider {...settings}>
                                                        {
                                                            selectImage.map((el, i) => {
                                                                if (el.type === "local") {
                                                                    return (
                                                                        <div className='image' key={i}>
                                                                            <PhotoView src={el.file}>
                                                                                <img src={el.file} alt="logo restaurant" />
                                                                            </PhotoView>
                                                                        </div>
                                                                    )
                                                                } else {
                                                                    return (
                                                                        <div className='image' key={i}>
                                                                            <PhotoView src={BASE_URL + el.file}>
                                                                                <img src={BASE_URL + el.file} alt="logo restaurant" />
                                                                            </PhotoView>
                                                                        </div>
                                                                    )
                                                                }


                                                            })
                                                        }
                                                    </Slider>
                                                    : <div className="no_image_slide"><i className='fa fa-photo'></i> <p>Pas de photo ...</p></div>}

                                            </div>
                                        </PhotoProvider>

                                        <div className='resto_description'>
                                            <h2> <i className='fa fa-tag'></i>Description du restaurant</h2>
                                            <div className='resto_description_content'>
                                                <div className='chef'>
                                                    <img src={Chef} alt="chef avatar" />
                                                </div>
                                                <p>{description === null ? 'Description non disponible ...' : description.split('\n').map((line, index) => (
                                                    <div key={index}>{line}</div>
                                                ))}</p>
                                            </div>

                                        </div>



                                        <div className='row'>


                                            <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8'>
                                                <Tabs
                                                    defaultActiveKey="carte"
                                                    id="fill-tab-example"
                                                    className="mb-3"
                                                    justify
                                                >
                                                    <Tab eventKey="carte" title="Cartes">
                                                        {entrer.length === 0 && plat.length === 0 && dessert.length === 0 && boisson.length === 0 ?
                                                            <h4> <i className='fa fa-cutlery pas'></i>Pas de contenue dans la carte</h4>
                                                            :
                                                            <h4> <i className='fa fa-cutlery'></i>A la carte</h4>
                                                        }

                                                        <div className='resto_carte'>
                                                            <div className='row'>
                                                                {entrer.length !== 0 ?
                                                                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                                        <div className='resto_carte_bloc'>
                                                                            <h5 className='text-center'>Entrées</h5>
                                                                            {entrer.map((item, index) => {
                                                                                if (index === entrer.length - 1) {
                                                                                    return (<div className='resto_entrer' key={index}>
                                                                                        <div className='img'>
                                                                                            <img src={EntrerIcon} alt="avatar carte" />
                                                                                        </div>
                                                                                        <div className='resto_carte_content'>
                                                                                            <h6>{item.libelle}</h6>
                                                                                            <span>{item.prix} Ar</span>
                                                                                        </div>
                                                                                    </div>)
                                                                                } else {
                                                                                    return (<>
                                                                                        <div className='resto_entrer' key={index}>
                                                                                            <div className='img'>
                                                                                                <img src={EntrerIcon} alt="avatar carte" />
                                                                                            </div>
                                                                                            <div className='resto_carte_content'>
                                                                                                <h6>{item.libelle}</h6>
                                                                                                <span>{item.prix} Ar</span>
                                                                                            </div>
                                                                                        </div>
                                                                                        <hr />
                                                                                    </>)
                                                                                }

                                                                            })}


                                                                        </div>
                                                                    </div>
                                                                    : ''}

                                                                {plat.length !== 0 ?
                                                                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                                        <div className='resto_carte_bloc'>
                                                                            <h5 className='text-center'>Plats</h5>
                                                                            {plat.map((item, index) => {
                                                                                if (index === plat.length - 1) {
                                                                                    return (<div className='resto_plat' key={index}>
                                                                                        <div className='img'>
                                                                                            <img src={PlatIcon} alt="avatar carte" />
                                                                                        </div>
                                                                                        <div className='resto_carte_content'>
                                                                                            <h6>{item.libelle}</h6>
                                                                                            <span>{item.prix} Ar</span>
                                                                                        </div>
                                                                                    </div>)
                                                                                } else {
                                                                                    return (<>
                                                                                        <div className='resto_plat' key={index}>
                                                                                            <div className='img'>
                                                                                                <img src={PlatIcon} alt="avatar carte" />
                                                                                            </div>
                                                                                            <div className='resto_carte_content'>
                                                                                                <h6>{item.libelle}</h6>
                                                                                                <span>{item.prix} Ar</span>
                                                                                            </div>
                                                                                        </div>
                                                                                        <hr />
                                                                                    </>
                                                                                    )
                                                                                }

                                                                            })}

                                                                        </div>
                                                                    </div>
                                                                    : ''}


                                                                {dessert.length !== 0 ?
                                                                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
                                                                        <div className='resto_carte_bloc'>
                                                                            <h5 className='text-center'>Desserts</h5>

                                                                            {dessert.map((item, index) => {
                                                                                if (index === dessert.length - 1) {
                                                                                    return (
                                                                                        <div className='resto_dessert' key={index}>
                                                                                            <div className='img'>
                                                                                                <img src={DessertIcon} alt="avatar carte" />
                                                                                            </div>
                                                                                            <div className='resto_carte_content'>
                                                                                                <h6>{item.libelle}</h6>
                                                                                                <span>{item.prix} Ar</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    )
                                                                                } else {
                                                                                    return (
                                                                                        <>
                                                                                            <div className='resto_dessert' key={index}>
                                                                                                <div className='img'>
                                                                                                    <img src={DessertIcon} alt="avatar carte" />
                                                                                                </div>
                                                                                                <div className='resto_carte_content'>
                                                                                                    <h6>{item.libelle}</h6>
                                                                                                    <span>{item.prix} Ar</span>
                                                                                                </div>
                                                                                            </div>
                                                                                            <hr />
                                                                                        </>
                                                                                    )
                                                                                }
                                                                            })}


                                                                        </div>

                                                                    </div>
                                                                    : ''}


                                                                {boisson.length !== 0 ?

                                                                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
                                                                        <div className='resto_carte_bloc'>
                                                                            <h5 className='text-center boisson'>Boissons</h5>
                                                                            {boisson.map((item, index) => {
                                                                                if (index === boisson.length - 1) {
                                                                                    return (
                                                                                        <div className='resto_boisson' key={index}>
                                                                                            <div className='img'>
                                                                                                <img src={BoissonIcon} alt="avatar carte" />
                                                                                            </div>
                                                                                            <div className='resto_carte_content'>
                                                                                                <h6>{item.libelle}</h6>
                                                                                                <span>{item.prix} Ar</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    )
                                                                                } else {
                                                                                    return (
                                                                                        <>
                                                                                            <div className='resto_boisson' key={index}>
                                                                                                <div className='img'>
                                                                                                    <img src={BoissonIcon} alt="avatar carte" />
                                                                                                </div>
                                                                                                <div className='resto_carte_content'>
                                                                                                    <h6>{item.libelle}</h6>
                                                                                                    <span>{item.prix} Ar</span>
                                                                                                </div>
                                                                                            </div>
                                                                                            <hr />
                                                                                        </>
                                                                                    )
                                                                                }
                                                                            })}



                                                                        </div>

                                                                    </div>
                                                                    : ''}

                                                            </div>
                                                        </div>
                                                    </Tab>



                                                    <Tab eventKey="menu" title="Menus">
                                                        {menu.length === 0 ? <h4> <i className='fa fa-cutlery pas'></i>Pas de contenu dans le Menus</h4> : <h4> <i className='fa fa-cutlery'></i>Menus</h4>}

                                                        <div className="row p-2">

                                                            {menu.map((item, index) => {
                                                                return (
                                                                    <div className='col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4' key={index}>
                                                                        <div className='resto_menus'>
                                                                            <div className='resto_menu_header'>
                                                                                <div className='img'>
                                                                                    <img src={Menus} alt="avatar menus" />
                                                                                </div>
                                                                                <div className='resto_menu_titre'>
                                                                                    <h5>{item.nomMenu} à <span>{item.prixMenu} Ar</span></h5>
                                                                                </div>
                                                                            </div>
                                                                            <div className='resto_menu_content'>
                                                                                <p>{item.introduire.slice(0, 80)}...</p>
                                                                                <div className='d-flex justify-content-center'>
                                                                                    <button className='btn' onClick={() => handleShowDetailMenu(item)}>Voir le détail de ce menu</button>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}

                                                        </div>


                                                    </Tab>



                                                    <Tab eventKey="avecOffre" title="Avec Offres">
                                                        <div className='resto_promo_map'>
                                                            <div className='row'>
                                                                <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                                    <div className='resto_promo_titre'>
                                                                        <h4> <i className='fa fa-bullhorn'></i>Avec Offre</h4>
                                                                    </div>
                                                                    <div className='resto_promo_content'>

                                                                        {promotion.length !== 0 ?
                                                                            promotion.map((elPromo, iPromo) => {
                                                                                if (elPromo.libelle === "Promotion de -50%") {
                                                                                    return (<div className='resto_promo_content_item' key={iPromo}>
                                                                                        <div className='item_liste'>
                                                                                            <h5>Promo : -50% sur la carte</h5>
                                                                                            <span>Précision / conditions / validité</span>
                                                                                        </div>
                                                                                    </div>);
                                                                                } else if (elPromo.libelle === "Promotion de -40%") {
                                                                                    return (<div className='resto_promo_content_item' key={iPromo}>
                                                                                        <div className='item_liste'>
                                                                                            <h5>Promo : -40% sur la carte</h5>
                                                                                            <span>Précision / conditions / validité</span>
                                                                                        </div>
                                                                                    </div>);
                                                                                } else if (elPromo.libelle === "Promotion de -30%") {
                                                                                    return (<div className='resto_promo_content_item' key={iPromo}>
                                                                                        <div className='item_liste'>
                                                                                            <h5>Promo : -30% sur la carte</h5>
                                                                                            <span>Précision / conditions / validité</span>
                                                                                        </div>
                                                                                    </div>);
                                                                                } else if (elPromo.libelle === "Promotion de -20%") {
                                                                                    return (<div className='resto_promo_content_item' key={iPromo}>
                                                                                        <div className='item_liste'>
                                                                                            <h5>Promo : -20% sur la carte</h5>
                                                                                            <span>Précision / conditions / validité</span>
                                                                                        </div>
                                                                                    </div>);
                                                                                } else if (elPromo.libelle === "Promotion de -10%") {
                                                                                    return (<div className='resto_promo_content_item' key={iPromo}>
                                                                                        <div className='item_liste'>
                                                                                            <h5>Promo : -10% sur la carte</h5>
                                                                                            <span>Précision / conditions / validité</span>
                                                                                        </div>
                                                                                    </div>);
                                                                                } else if (elPromo.libelle === "Promotion : Menu spécial") {
                                                                                    return (<div className='resto_promo_content_item' key={iPromo}>
                                                                                        <div className='item_liste'>
                                                                                            <h5>Promo : {promoSpecial.length !== 0 ? promoSpecial[0].libelle : "Promotion special"} à {promoSpecial.length !== 0 ? promoSpecial[0].prix : "000"} Ar</h5>
                                                                                            <span>Précision / conditions / validité</span>
                                                                                        </div>
                                                                                        <div className='item_action_creneau creneau_special'>
                                                                                            {promoSpecial.lenght !== 0 ? <span className="item_detail_menu" onClick={handleShowDetailSPecial}>Voir le détail de ce menu</span> : ''}
                                                                                        </div>
                                                                                        <div className='item_action_content'>
                                                                                            <div className='item_action_creneau_responsive'>
                                                                                                {promoSpecial.lenght !== 0 ? <span className="item_detail_menu" onClick={handleShowDetailSPecial}>Voir le détail de ce menu</span> : ''}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>)
                                                                                } else {
                                                                                    return ("");
                                                                                }
                                                                            })
                                                                            : <p>Pas de promotion ...</p>}

                                                                    </div>
                                                                    <div className='resto_promo_titre mt-3'>
                                                                        <h4> <i className='fa fa-bullhorn'></i>Sans Offre</h4>
                                                                    </div>
                                                                    <div className='resto_promo_content'>
                                                                        <div className='resto_promo_content_item'>
                                                                            <div className='item_liste'>
                                                                                <h5>Réservations simple</h5>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </Tab>




                                                    <Tab eventKey="avis" title={"Nombre d'avis" + restaurant?.avis?.length}>
                                                        <div className='resto_avis'>
                                                            <div className='resto_avis_header'>
                                                                <h4><i className='fa fa-tag'></i> Nombre d'avis {restaurant?.avis?.length}</h4>
                                                            </div>
                                                            <div className='resto_avis_content'>

                                                                {restaurant?.avis?.map((el, index) => {
                                                                    return (
                                                                        viewAvisListe(el, index)
                                                                    )
                                                                })}



                                                                {/* <div className='d-flex justify-content-center'>
                                                                    <div className='pagination_avis'>
                                                                        <Pagination count={10} />
                                                                    </div>
                                                                </div> */}
                                                            </div>
                                                        </div>
                                                    </Tab>
                                                </Tabs>

                                            </div>


                                            <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4'>
                                                <div className='payement_plus'>
                                                    <div className='payement_plusContent'>
                                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                            <div className='plus_restaurant'>
                                                                <div className='d-flex justify-content-center'>
                                                                    <div className='titre_plus'>
                                                                        <span><i className='fa fa-bolt'></i> Les + du restaurant</span>
                                                                    </div>
                                                                </div>
                                                                <div className='plus_content'>
                                                                    <div className='row'>
                                                                        {existeService.length !== 0 ?
                                                                            existeService.map((item, index) => {
                                                                                return (
                                                                                    <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6' key={index}>
                                                                                        <div className='item_plus'>
                                                                                            <div className='image_plus'>
                                                                                                <img src={Plus} alt="avatar plus restaurant" />
                                                                                            </div>
                                                                                            <div className='value_plus'>
                                                                                                <span>{item.name}</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                )
                                                                            })
                                                                            : ''}
                                                                        {existeRegime.length !== 0 ?
                                                                            existeRegime.map((item, index) => {
                                                                                return (
                                                                                    <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6' key={index}>
                                                                                        <div className='item_plus'>
                                                                                            <div className='image_plus'>
                                                                                                <img src={Plus} alt="avatar plus restaurant" />
                                                                                            </div>
                                                                                            <div className='value_plus'>
                                                                                                <span>{item.name}</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                )
                                                                            })
                                                                            : ''}


                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                            <div className='payement_restaurant'>
                                                                <div className='payement_restaurantContent'>
                                                                    <div className='titre_payement'>
                                                                        <span><i className='fa fa-money'></i> Mode de payement acceptés</span>
                                                                    </div>
                                                                </div>
                                                                <div className='payement_content'>
                                                                    <div className='row'>
                                                                        {existePayement.length !== 0 ?
                                                                            existePayement.map((item, index) => {
                                                                                return (<div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6' key={index}>
                                                                                    <div className='item_payement'>
                                                                                        <div className='image_payement'>
                                                                                            <img src={Money} alt="avatar plus restaurant" />
                                                                                        </div>
                                                                                        <div className='value_payement'>
                                                                                            <span>{item.name}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>)
                                                                            })

                                                                            : ''}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                            <div className='resto_map'>
                                                                <div className='resto_map_titre'>
                                                                    <h4> <i className='fa fa-map-marker'></i>Localisation – Plan / adresse</h4>
                                                                </div>

                                                                <div className="resto_map_content">
                                                                    <h5>Adresse</h5>
                                                                    <p>{restaurant.adresse} : {precision}</p>
                                                                    <PhotoProvider>
                                                                        {icon !== true ?
                                                                            <div className='resto_map_image'>
                                                                                <PhotoView src={plan}>
                                                                                    <img src={plan} alt="plan restaurant" className='plan_restaurant' />
                                                                                </PhotoView>
                                                                            </div>

                                                                            : planUrl !== null ?
                                                                                <div className='resto_map_image'>
                                                                                    <PhotoView src={BASE_URL + planUrl}>
                                                                                        <img src={BASE_URL + planUrl} alt="plan restaurant" className='plan_restaurant' />
                                                                                    </PhotoView>
                                                                                </div>
                                                                                : ''
                                                                        }

                                                                    </PhotoProvider>


                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>






                                        <PhotoProvider>
                                            {restaurant?.photoRestos?.length !== 0 ?
                                                <div className="resto_photo_telecharger">
                                                    <div className='resto_photo_telecharger_titre'>
                                                        <h4> <i className='fa fa-photo'></i>Photo des clients</h4>
                                                    </div>
                                                    <div className='row'>
                                                        {restaurant?.photoRestos?.map((element, index) => {
                                                            return (
                                                                <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3' key={index}>
                                                                    <div className='resto_photo_img'>
                                                                        <PhotoView src={BASE_URL + element.photoUrl}>
                                                                            <img src={BASE_URL + element.photoUrl} alt="telecharger client" />
                                                                        </PhotoView>
                                                                    </div>
                                                                </div>)
                                                        })}


                                                    </div>
                                                </div>
                                                : ""}
                                        </PhotoProvider>

                                    </div>
                                    <Modal
                                        show={show}
                                        size="lg"
                                        aria-labelledby="contained-modal-title-vcenter"
                                        centered

                                        onHide={handleCloseDetailMenu}
                                    >
                                        <Modal.Body className="shadow">
                                            <div className='modal_detail_menu'>
                                                <div className='header_detail_menu'>
                                                    <h5>{elementMenu.nomMenu} à <span>{elementMenu.prixMenu} Ar</span></h5>
                                                    <span className='close' onClick={handleCloseDetailMenu}><i className='fa fa-close'></i></span>
                                                </div>
                                                <div className='content_detail_menu'>
                                                    <div className='content_detail_description'>
                                                        <h6>Ce menu comprend:</h6>
                                                        <div className='content_detail_liste mt-2'>
                                                            {elementMenu.platMenu !== "" && elementMenu.avecContenus?.length !== 0 ?
                                                                <><span className='detail_liste'>{elementMenu.platMenu}</span>
                                                                    <span className='detail_plus'>+</span></> :
                                                                elementMenu.platMenu !== "" && elementMenu.avecContenus?.length === 0 ?
                                                                    <span className='detail_liste'>{elementMenu.platMenu}</span>
                                                                    : ""
                                                            }

                                                            {elementMenu.autrePlatMenu !== "" && elementMenu.avecContenus?.length !== 0 ?
                                                                <><span className='detail_liste'>{elementMenu.autrePlatMenu}</span> <span className='detail_plus'>+</span></> :
                                                                elementMenu.autrePlatMenu !== "" && elementMenu.avecContenus?.length === 0 ?
                                                                    <span className='detail_liste'>{elementMenu.autrePlatMenu}</span> : ''}


                                                            {elementMenu.avecContenus?.length !== 0 ?
                                                                elementMenu.avecContenus?.map((elAvec, iAvec) => {
                                                                    if (iAvec === elementMenu.avecContenus?.length - 1) {
                                                                        return (<span className='detail_liste' key={iAvec}>{elAvec.libelle}</span>);
                                                                    } else {

                                                                        return (<div key={iAvec} ><span className='detail_liste'>{elAvec.libelle}</span><span className='detail_plus'>+</span></div>);
                                                                    }

                                                                })
                                                                : ''}
                                                        </div>
                                                        <h6>Ce menu disponible:</h6>
                                                        <div className='content_detail_liste mt-2'>

                                                            {elementMenu.moments?.length !== 0 ?
                                                                elementMenu.moments?.map((elMoment, iMoment) => {
                                                                    return (
                                                                        <span className='detail_liste_disponible' key={iMoment}>Au {elMoment.libelle}</span>
                                                                    );
                                                                }) : ""}



                                                        </div>
                                                        <div className='content_detail_liste mt-3'>
                                                            <span className='me-2' >Le</span>
                                                            {elementMenu.jours?.length !== 0 ?
                                                                elementMenu.jours?.map((elJour, iJour) => {
                                                                    return (<span className='detail_liste_disponible' key={iJour}>{elJour.libelle}</span>);
                                                                })
                                                                : ''}
                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        {elementMenu.entrerMenus?.length !== 0 ?
                                                            <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                                <div className='content_detail_item'>
                                                                    <div className='content_detail_itemTitre'>
                                                                        <h6 className='text-center'>Entrée</h6>

                                                                    </div>
                                                                    <div className='content_detail_itemListe'>
                                                                        {elementMenu.entrerMenus?.map((elEntrer, iEntrer) => {
                                                                            if (iEntrer === elementMenu.entrerMenus?.length - 1) {
                                                                                return (<span key={iEntrer}>{elEntrer.libelle}</span>);
                                                                            } else {

                                                                                return (<><span key={iEntrer}>{elEntrer.libelle}</span>
                                                                                    <hr /></>);
                                                                            }

                                                                        })}


                                                                    </div>
                                                                </div>
                                                            </div>
                                                            : ''}


                                                        {elementMenu.platMenus?.length !== 0 ?
                                                            <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                                <div className='content_detail_item'>
                                                                    <div className='content_detail_itemTitre'>
                                                                        <h6 className='text-center'>Plats</h6>

                                                                    </div>
                                                                    <div className='content_detail_itemListe'>
                                                                        {elementMenu.platMenus?.map((elPlat, iPlat) => {
                                                                            if (iPlat === elementMenu.platMenus?.length - 1) {
                                                                                return (<span key={iPlat}>{elPlat.libelle}</span>);
                                                                            } else {

                                                                                return (<><span key={iPlat}>{elPlat.libelle}</span>
                                                                                    <hr /></>)
                                                                            }
                                                                        })}


                                                                    </div>
                                                                </div>
                                                            </div>
                                                            : ''}


                                                        {elementMenu.dessertMenus?.length !== 0 ?
                                                            <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                                <div className='content_detail_item'>
                                                                    <div className='content_detail_itemTitre'>
                                                                        <h6 className='text-center'>Dessert</h6>

                                                                    </div>
                                                                    <div className='content_detail_itemListe'>
                                                                        {elementMenu.dessertMenus?.map((elDessert, iDessert) => {
                                                                            if (iDessert === elementMenu.dessertMenus?.length - 1) {
                                                                                return (<span key={iDessert}>{elDessert.libelle}</span>);
                                                                            } else {
                                                                                return (<><span key={iDessert}>{elDessert.libelle}</span>
                                                                                    <hr /></>)
                                                                            }
                                                                        })}

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            : ''}
                                                        {elementMenu.autreMenus?.length !== 0 ?
                                                            <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                                <div className='content_detail_item'>
                                                                    <div className='content_detail_itemTitre'>
                                                                        <h6 className='text-center'>{elementMenu.nomAutre}</h6>

                                                                    </div>
                                                                    <div className='content_detail_itemListe'>
                                                                        {elementMenu.autreMenus?.map((elAutre, iAutre) => {
                                                                            if (iAutre === elementMenu.autreMenus?.length - 1) {
                                                                                return (<span key={iAutre}>{elAutre.libelle}</span>);
                                                                            } else {
                                                                                return (<><span key={iAutre}>{elAutre.libelle}</span>
                                                                                    <hr /></>)
                                                                            }
                                                                        })}

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            : ''}

                                                    </div>
                                                    <p className='mt-3'>
                                                        {elementMenu.introduire}
                                                    </p>
                                                </div>
                                            </div>
                                        </Modal.Body>
                                    </Modal>





                                    <Modal
                                        show={showSpecial}
                                        size="lg"
                                        aria-labelledby="contained-modal-title-vcenter"
                                        centered

                                        onHide={handleCloseDetailSpecial}
                                    >
                                        <Modal.Body className="shadow">
                                            <div className='modal_detail_menu'>
                                                <div className='header_detail_menu'>
                                                    <h5>{promoSpecial[0]?.libelle} à <span>{promoSpecial[0]?.prix} Ar</span></h5>
                                                    <span className='close' onClick={handleCloseDetailSpecial}><i className='fa fa-close'></i></span>
                                                </div>
                                                <div className='content_detail_menu'>
                                                    <div className='content_detail_description'>
                                                        <h6>Ce menu comprend:</h6>
                                                        <div className='content_detail_liste mt-2'>

                                                            <span className='detail_liste'>{promoSpecial[0]?.platMenu !== "" ? promoSpecial[0]?.platMenu : promoSpecial[0]?.autrePlatMenu}</span>

                                                            {promoSpecial[0]?.avecContenuSpecials?.length !== 0 ?
                                                                <>
                                                                    <span className='detail_plus'>+</span>
                                                                    {promoSpecial[0]?.avecContenuSpecials?.map((elAvec, iAvec) => {
                                                                        if (iAvec === promoSpecial[0]?.avecContenuSpecials?.length - 1) {
                                                                            return (<span className='detail_liste' key={iAvec}>{elAvec.libelle}</span>);
                                                                        } else {
                                                                            return (<div key={iAvec} ><span className='detail_liste'>{elAvec.libelle}</span><span className='detail_plus'>+</span></div>);
                                                                        }

                                                                    })}
                                                                </>
                                                                : ''}
                                                        </div>

                                                    </div>
                                                    <div className='row'>
                                                        {promoSpecial[0]?.entrerSpecials?.length !== 0 ?
                                                            <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                                <div className='content_detail_item'>
                                                                    <div className='content_detail_itemTitre'>
                                                                        <h6 className='text-center'>Entrée</h6>

                                                                    </div>
                                                                    <div className='content_detail_itemListe'>
                                                                        {promoSpecial[0]?.entrerSpecials?.map((elEntrer, iEntrer) => {
                                                                            if (iEntrer === promoSpecial[0]?.entrerSpecials?.length - 1) {
                                                                                return (<span key={iEntrer}>{elEntrer.libelle}</span>);
                                                                            } else {

                                                                                return (<><span key={iEntrer}>{elEntrer.libelle}</span>
                                                                                    <hr /></>);
                                                                            }

                                                                        })}


                                                                    </div>
                                                                </div>
                                                            </div>
                                                            : ''}


                                                        {promoSpecial[0]?.platSpecials?.length !== 0 ?
                                                            <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                                <div className='content_detail_item'>
                                                                    <div className='content_detail_itemTitre'>
                                                                        <h6 className='text-center'>Plats</h6>

                                                                    </div>
                                                                    <div className='content_detail_itemListe'>
                                                                        {promoSpecial[0]?.platSpecials?.map((elPlat, iPlat) => {
                                                                            if (iPlat === promoSpecial[0]?.platSpecials?.length - 1) {
                                                                                return (<span key={iPlat}>{elPlat.libelle}</span>);
                                                                            } else {

                                                                                return (<><span key={iPlat}>{elPlat.libelle}</span>
                                                                                    <hr /></>)
                                                                            }
                                                                        })}


                                                                    </div>
                                                                </div>
                                                            </div>
                                                            : ''}


                                                        {promoSpecial[0]?.dessertSpecials?.length !== 0 ?
                                                            <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                                <div className='content_detail_item'>
                                                                    <div className='content_detail_itemTitre'>
                                                                        <h6 className='text-center'>Dessert</h6>

                                                                    </div>
                                                                    <div className='content_detail_itemListe'>
                                                                        {promoSpecial[0]?.dessertSpecials?.map((elDessert, iDessert) => {
                                                                            if (iDessert === promoSpecial[0]?.dessertSpecials?.length - 1) {
                                                                                return (<span key={iDessert}>{elDessert.libelle}</span>);
                                                                            } else {
                                                                                return (<><span key={iDessert}>{elDessert.libelle}</span>
                                                                                    <hr /></>)
                                                                            }
                                                                        })}

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            : ''}


                                                        {promoSpecial[0]?.autreSpecials?.length !== 0 ?
                                                            <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                                <div className='content_detail_item'>
                                                                    <div className='content_detail_itemTitre'>
                                                                        <h6 className='text-center'>{promoSpecial[0]?.nomAutre}</h6>

                                                                    </div>
                                                                    <div className='content_detail_itemListe'>
                                                                        {promoSpecial[0]?.autreSpecials?.map((elAutre, iAutre) => {
                                                                            if (iAutre === promoSpecial[0]?.autreSpecials?.length - 1) {
                                                                                return (<span key={iAutre}>{elAutre.libelle}</span>);
                                                                            } else {
                                                                                return (<><span key={iAutre}>{elAutre.libelle}</span>
                                                                                    <hr /></>)
                                                                            }
                                                                        })}

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            : ''}

                                                    </div>
                                                    <p className='mt-3'>
                                                        {promoSpecial[0]?.introduire}
                                                    </p>
                                                </div>
                                            </div>
                                        </Modal.Body>
                                    </Modal>


                                </div>

                            </div>
                        </Modal.Body>
                    </Modal>



                </div>
            </div>






        </div>
    )
}

export default ProfileResto